import ResetPasswordContainer from "../../Componant/Authentication/ResetPassword";

const ResetPassword = () => {
  return (
    <div className="page-wrapper">
      <ResetPasswordContainer />
    </div>
  );
};

export default ResetPassword;
